export enum ScreensAddWizardBlock {
  Root = 'ScreensAddWizard',
}
